import { render, staticRenderFns } from "./infoicon.vue?vue&type=template&id=132b9538&"
import script from "./../../ts/articleattributes/infoicon.ts?vue&type=script&lang=js&"
export * from "./../../ts/articleattributes/infoicon.ts?vue&type=script&lang=js&"
import style0 from "./../../assets/css/articleattributes/infoicon.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports